export const TOKEN_PREFIX = 'elga-cargo';
export const AUTH_TOKEN = `${TOKEN_PREFIX}/token`;
export const LOCALE = `${TOKEN_PREFIX}/locale`;
